
// src/web/components/left-sidebar.jsx

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import connect from '../../connects/left-sidebar'
import _ from 'lodash'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import FontIcon from 'react-toolbox/lib/font_icon'
import LeftSidebarGroupList from './left-sidebar-group-list.jsx'
import GroupCreatePage from './group-create-page.jsx'
import ConfirmDialog from './confirm-dialog.jsx'
import leftSidebarGroupListItemTheme from './themes/left-sidebar-group-list-item.css'
import warningIconTheme from './themes/warning-icon.css'
import noScrollBarTheme from './themes/no-scrollbar.css'
import { track } from '../../helpers/analytics'
class LeftSidebar extends PureComponent {
  state = {}

  onCreateGroup = () => {
    if (this.props.user && this.props.user.group_creatable) {
      this.props.updateUI({ active: true })
    }
  }
  onClose = () => this.props.updateUI({ active: false })
  selectHome = () => this.props.selectGroup('home', this.props)
  onAnnounceClick = () => this.props.openAnnouncePage()
  onEmailConfirmClick = () => this.setState({ emailConfirm: !this.state.emailConfirm })
  requestConfirmationMail = () => {
    this.setState({ emailConfirm: false })
    this.props.requestConfirmationMail()
  }
  onReloadClick = () => this.setState({ reloadNeeded: !this.state.reloadNeeded })
  onReload = () => {
    location.reload(true)
  }
  activateZendesk = ()=> zE.activate({ hideOnClose: true })
  openHelpPage = ()=> {
    window.open('https://support.getgamba.com/hc/ja')
    track('open_help')
  }
  onSortGroup = ()=> this.props.updateUI({ sortActive: true })
  onSortGroupClose = ()=> this.props.updateUI({ sortActive: false })
  onFilter = () => this.props.updateUI({ isFilter: !this.props.ui.isFilter })

  render() {
    const {
      t,
      ui,
      organizations,
      MemberGroups,
      publicOtherGroups,
      groups,
      divisions,
      user,
      group_id,
      currentDivisionId,
      selectGroup,
      selectDivision,
      selectOrganization,
      openUserSettingsPage,
      openSortGroup,
      onSearchChange,
      updateUI,
      reloadNeeded,
      routes,
      latest,
      close,
      unreadGroupsCount,
      unreadGroups,
      menuItems,
      expandDivision,
      collapseDivision,
      expandedDivisions,
      expandDivisionNotSetGroup,
      canExpandDivNotSetGroup,
      selectDivisionNotSetGroup
    } = this.props

    return (
      <div className={noScrollBarTheme.noScrollBar}>
          {(!close || user && user.unconfirmed || groups && groups.length > 1 || reloadNeeded) &&
            <List selectable theme={leftSidebarGroupListItemTheme}>
              {reloadNeeded &&
                <ListItem leftIcon={<FontIcon value='warning' className={warningIconTheme.warning}/>}
                  theme={leftSidebarGroupListItemTheme}
                  caption={t('label:更新が必要です')}
                  onClick={this.onReloadClick} />
              }
              {!close && <ListItem leftIcon={<FontIcon value='error' className={warningIconTheme.warning}/>}
                  theme={leftSidebarGroupListItemTheme}
                  caption={t('label:お知らせがあります')}
                  onClick={this.onAnnounceClick} />
              }
              {user && user.unconfirmed &&
                <ListItem leftIcon={<FontIcon value='warning' style={{ color: '#FFCC00' }}/>}
                  theme={leftSidebarGroupListItemTheme}
                  caption={t('label:メールアドレスを確認してください')}
                  onClick={this.onEmailConfirmClick} />
              }
              {groups && groups.length > 1 &&
                <ListItem leftIcon='home'
                  className={group_id == 'home' && 'active' || ''}
                  theme={leftSidebarGroupListItemTheme}
                  caption={t('label:すべてのグループ')}
                  onClick={this.selectHome}
                  rightActions={unreadGroupsCount && [<span key='count' className={leftSidebarGroupListItemTheme.unreadCount}>{unreadGroupsCount < 10 ? unreadGroupsCount : '10+' }</span>] || []}/>
              }
            </List>
          }
          <LeftSidebarGroupList t={t} labelText={ui.isFilter ? t('label:Section(unread)') : t('label:Section')}
              isFilter={ui.isFilter}
              onFilter={this.onFilter}
              currentGroupId={group_id}
              currentDivisionId={currentDivisionId}
              groups={MemberGroups}
              divisions={divisions}
              unreadGroups={unreadGroups}
              menuItems={menuItems}
              otherGroups={publicOtherGroups}
              selectGroup={selectGroup}
              selectDivision={selectDivision}
              onCreateGroup={this.props.user && this.props.user.group_creatable && this.onCreateGroup}
              onSearchChange={onSearchChange}
              openSortGroup={openSortGroup}
              expandDivision={expandDivision}
              collapseDivision={collapseDivision}
              expandedDivisions={expandedDivisions}
              expandDivisionNotSetGroup={expandDivisionNotSetGroup}
              canExpandDivNotSetGroup={canExpandDivNotSetGroup}
              selectDivisionNotSetGroup={selectDivisionNotSetGroup}
          />

        <GroupCreatePage active={ui.active} onClose={this.onClose}/>

        <ConfirmDialog open={this.state.reloadNeeded}
          title={t('label:更新が必要です')}
          description={t('label:サービスが更新されています')}
          yesLabel={t('label:更新する')}
          noLabel={t('label:閉じる')}
          onYes={this.onReload}
          onNo={this.onReloadClick} />

        <ConfirmDialog open={this.state.emailConfirm}
          title={t('label:メールアドレスの確認が完了していません')}
          description={t('label:メールアドレスの確認を行ってください')}
          yesLabel={t('label:確認メール再送')}
          noLabel={t('label:閉じる')}
          onYes={this.requestConfirmationMail}
          onNo={this.onEmailConfirmClick} />
      </div>
    )
  }
}

export const RawLeftSidebar = LeftSidebar
export default connect(LeftSidebar)



// WEBPACK FOOTER //
// ./src/web/components/left-sidebar.jsx